import { FC } from 'react';
import { Dropdown } from '@dynamika-shared/ui/Dropdown/Dropdown';
import { User } from '@dynamika-shared/types/users';
import {
  DotsIcon,
  EditIcon,
  MailIcon,
  SuspendIcon,
  CheckCircleIcon,
} from '@dynamika-shared/ui/icons';
import { DropdownOptionType, MakeUsersColumnsType } from './UsersTable.columns';
import { useAuth } from '@hooks/useAuth';

type UserListActionsProps = {
  user: User;
  onUserClick: MakeUsersColumnsType['onUserClick'];
};
export const UserListActionsRenderer: FC<UserListActionsProps> = ({
  onUserClick,
  user,
}) => {
  const { user: authUser } = useAuth();
  return (
    <div className='ml-1 flex items-center justify-center'>
      <Dropdown
        items={[
          {
            key: DropdownOptionType.edit,
            label: 'Edit',
            icon: <EditIcon />,
          },
          user.enabled
            ? {
                key: DropdownOptionType.deactivate,
                label: 'Deactivate',
                icon: <SuspendIcon />,
                disabled:
                  authUser?.['dynamika7/user_metadata']?.uuid === user?.id,
              }
            : {
                key: DropdownOptionType.reactivate,
                label: 'Activate',
                icon: <CheckCircleIcon />,
              },
          {
            key: DropdownOptionType.resendInvite,
            label: 'Resend invite',
            icon: <MailIcon />,
            disabled: !!user?.lastActivity || !user?.enabled,
          },
        ]}
        overlayClassName={'w-[20rem]'}
        trigger={['click']}
        onClick={e => onUserClick(user, e.key as unknown as DropdownOptionType)}
      >
        <div className='flex h-5 cursor-pointer items-center justify-center'>
          <div className='rounded-3xl p-1 hover:bg-waterLight'>
            <DotsIcon className='hover:text-black' />
          </div>
        </div>
      </Dropdown>
    </div>
  );
};
